import { z } from 'zod';

export const CodeSystemSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export type CodeSystem = z.infer<typeof CodeSystemSchema>;
